import { z } from 'zod';

export const DeviceInfoDtoScheme = z.object({
	client_id: z.string().describe('Устойчивый идентификатор устройства'),
	has_persistent_storage: z.boolean().describe('Идентификатор восстановлен из хранилища'),

	platform: z.string().nullable().describe('Платформа'),
	platform_version: z.string().nullable().describe('Версия ОС'),
	model: z.string().nullable().describe('Модель устройства'),
	browser_version: z.string().nullable().describe('Полная версия браузера'),
	is_mobile: z.boolean().nullable().describe('Мобильное устройство'),

	screen_width: z.number().nullable().describe('Ширина экрана'),
	screen_height: z.number().nullable().describe('Высота экрана'),
	pixel_ratio: z.number().nullable().describe('Плотность пикселей'),
	color_depth: z.number().nullable().describe('Глубина цвета'),

	timezone: z.string().nullable().describe('Часовой пояс'),
	language: z.string().nullable().describe('Язык'),
	hardware_concurrency: z.number().nullable().describe('Количество ядер CPU'),
	device_memory: z.number().nullable().describe('Объем ОЗУ (Гб)'),
	max_touch_points: z.number().nullable().describe('Количество точек касания'),
	gpu: z.string().nullable().describe('Видеоадаптер'),

	network_type: z.string().nullable().describe('Тип сети'),
	network_effective_type: z.string().nullable().describe('Качество сети'),

	is_incognito: z.boolean().describe('Приватный режим браузера'),
	incognito_reason: z.string().nullable().describe('Чем определен приватный режим'),
});

export type DeviceInfoDto = z.infer<typeof DeviceInfoDtoScheme>;

export const UserDeviceDtoScheme = z.object({
	id: z.number().nullable().optional().describe('Уникальный идентификатор'),
	fingerprint: z.string().describe('Отпечаток устройства'),
	hardware_hash: z.string().describe('Отпечаток железа'),
	client_id: z.string().nullable().optional().describe('Идентификатор из хранилища браузера'),
	os: z.string().nullable().optional().describe('Операционная система'),
	os_version: z.string().nullable().optional().describe('Версия ОС'),
	browser: z.string().nullable().optional().describe('Браузер'),
	browser_version: z.string().nullable().optional().describe('Версия браузера'),
	device_type: z.string().nullable().optional().describe('Тип устройства'),
	device_model: z.string().nullable().optional().describe('Модель устройства'),
	platform: z.string().nullable().optional().describe('Платформа'),
	screen: z.string().nullable().optional().describe('Экран'),
	timezone: z.string().nullable().optional().describe('Часовой пояс'),
	language: z.string().nullable().optional().describe('Язык'),
	gpu: z.string().nullable().optional().describe('Видеоадаптер'),
	last_ip: z.string().nullable().optional().describe('Последний IP адрес'),
	last_network_type: z.string().nullable().optional().describe('Последний тип сети'),
});

export type UserDeviceDto = z.infer<typeof UserDeviceDtoScheme>;

/**
 * Устройство одной строкой: "Android 13 · Chrome 120 · SM-A536E"
 */
export function formatUserDevice(device?: UserDeviceDto | null): string {
	if (!device) return '';
	const os = [device.os, device.os_version].filter(Boolean).join(' ');
	const browser = [device.browser, device.browser_version?.split('.')[0]].filter(Boolean).join(' ');
	return [os, browser, device.device_model].filter(Boolean).join(' · ');
}
